import { render, staticRenderFns } from "./VideoModel.vue?vue&type=template&id=08f67806&scoped=true"
import script from "./VideoModel.vue?vue&type=script&lang=js"
export * from "./VideoModel.vue?vue&type=script&lang=js"
import style0 from "./VideoModel.vue?vue&type=style&index=0&id=08f67806&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f67806",
  null
  
)

export default component.exports